import { Flex, Grid, GridItem, Text, Button, useToast } from '@chakra-ui/react'
import React from 'react'
import { ImagensCaricaturaLista } from './ImagensCaricaturaLista'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../../services/api'
import { ModalValidarCaricatura } from './ModalValidar'
import { useNavigate } from 'react-router-dom'

async function approveCaricature({ id_imagens, numero_nota }) {
  const res = await api.put('/site/v2/fluxo-layout/aprovar-ilustracao-layout', {
    id_imagem: id_imagens,
    numero_nota: numero_nota,
  })

  return res.data
}

export const CaricaturaLista = ({ data, numeroNota }) => {
  const queryClient = useQueryClient()
  const toast = useToast({
    position: 'top-right',
    isClosable: true,
  })

  const navigate = useNavigate()

  const { mutateAsync: approveCaricatureAsync, isLoading } = useMutation(approveCaricature, {
    onSuccess: () => {
      queryClient.invalidateQueries(['validacao-caricatura-pro', { numero_nota: numeroNota }])
      queryClient.invalidateQueries(['validacao-caricatura', { numero_nota: numeroNota }])

      toast({
        title: 'Caricatura aprovada com sucesso',
        status: 'success',
      })

      if (data.length === 1) {
        navigate('/arte-final/validacao-de-caricatura')
      }
    },
    onError: (data) => {
      toast({
        title: 'Erro ao aprovar caricatura',
        description: `${data.response.data.erros}`,
        status: 'error',
      })
    },
  })

  async function handleApprove(idImagens) {
    const params = {
      id_imagens: idImagens,
      numero_nota: numeroNota,
    }

    console.log(params)

    await approveCaricatureAsync(params)
  }

  if (!data) return null

  return data?.map((item, index) => (
    <Grid templateColumns="repeat(6, 1fr)" gap={4} key={index}>
      <GridItem>
        <Flex flexDir="column" gap={4}>
          <Flex flexDir="column" gap={1}>
            <Text fontSize="sm" as="span">
              Nome do Representado: <strong>{item.nome}</strong>
            </Text>
            <Text fontSize="sm" as="span">
              ID: <strong>{item.images[0]?.id_tabela}</strong>
            </Text>
            <Text fontSize="sm" as="span">
              Quantidade: <strong>{item.images[0]?.quantidade}</strong>
            </Text>

            {item.cliente && (
              <Text fontSize="sm" as="span">
                Cliente: <strong>{item.cliente}</strong>
              </Text>
            )}
          </Flex>
          <ModalValidarCaricatura
            isLoadingApprove={isLoading}
            caricatura={item}
            onApprove={() => handleApprove(item.images.map((image) => image.id_tabela))}
          />
        </Flex>
      </GridItem>
      <ImagensCaricaturaLista idTabela={item.id_tabela} images={item.images} />
    </Grid>
  ))
}
